import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { SiteShippingToolBuildPart } from './site-shipping-tool-build-part';

export class SampleManagementBuildPart extends BaseBuildPart {
    constructor(
        private readonly overviewHelperParams: HelperParams,
        parent: BaseBuildPart) {
        super(overviewHelperParams, parent, ['sample-management']);
    }

    public pendingRegistration(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['pending', 'registration' , 'list']);
    }

    public registeredSamples(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['registered', 'samples', 'list']);
    }

    public registerNewSample(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['sample', 'registration']);
    }

    public ereqSampleRegistration(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['ereq', 'sample', 'registration']);
    }

    public resumeRegistration(type = 'resume'): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, [type, 'sample', 'registration']);
    }

    public siteShipping(): SiteShippingToolBuildPart {
        return new SiteShippingToolBuildPart(this.overviewHelperParams, this);
    }

    public eReqSampleManagementHome(accession: string): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, [ 'register', accession]);
    }
}
